module.exports = __webpack_public_path__ + "img/DSC_9283.ba83e9e0.jpg";